module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point03/th_04-7a303055b57b0bfe029484685bcf7290.jpg";